(function () {
  'use strict';

  var BANNER_ID = 'cookie-consent';
  var STORE_KEY = 'cdx_cookie_consent';
  var MAX_AGE = 31536000;
  var CATS = ['analytics', 'marketing', 'preferences'];

  function ready(fn) {
    if (document.readyState !== 'loading') {
      fn();
    } else {
      document.addEventListener('DOMContentLoaded', fn);
    }
  }

  function readLocal() {
    var raw = null;
    try { raw = window.localStorage.getItem(STORE_KEY); } catch (e) {}
    if (!raw) {
      var m = document.cookie.match(new RegExp('(?:^|; )' + STORE_KEY + '=([^;]*)'));
      if (m) {
        try { raw = decodeURIComponent(m[1]); } catch (e) { raw = null; }
      }
    }
    if (!raw) return null;
    try {
      var d = JSON.parse(raw);
      if (!d || !d.c || !d.t) return null;
      if (Date.now() - d.t > MAX_AGE * 1000) return null;
      return d;
    } catch (e) {
      return null;
    }
  }

  function writeLocal(consent) {
    var raw = JSON.stringify({ t: Date.now(), c: consent });
    try { window.localStorage.setItem(STORE_KEY, raw); } catch (e) {}
    try {
      document.cookie = STORE_KEY + '=' + encodeURIComponent(raw) +
        '; path=/; max-age=' + MAX_AGE + '; SameSite=Lax' +
        (window.location.protocol === 'https:' ? '; Secure' : '');
    } catch (e) {}
  }

  function apiConsent(privacy) {
    try {
      if (!privacy || typeof privacy.currentVisitorConsent !== 'function') return null;
      var c = privacy.currentVisitorConsent();
      if (!c) return null;
      var decided = CATS.some(function (k) {
        return c[k] === 'yes' || c[k] === 'no' || c[k] === true || c[k] === false;
      });
      if (!decided) return null;
      var yes = function (v) { return v === 'yes' || v === true; };
      return {
        analytics: yes(c.analytics),
        marketing: yes(c.marketing),
        preferences: yes(c.preferences),
        sale_of_data: yes(c.sale_of_data !== undefined ? c.sale_of_data : c.marketing)
      };
    } catch (e) {
      return null;
    }
  }

  function pushToApi(privacy, consent) {
    try {
      if (privacy && typeof privacy.setTrackingConsent === 'function') {
        privacy.setTrackingConsent(consent, function (error) {
          if (error && window.console) console.warn('[cookie-consent] setTrackingConsent:', error);
        });
      }
    } catch (e) {
      if (window.console) console.warn('[cookie-consent]', e);
    }
  }

  function initBanner(privacy) {
    var banner = document.getElementById(BANNER_ID);
    if (!banner) return;

    function show() {
      banner.classList.add('is-visible');
      banner.setAttribute('aria-hidden', 'false');
    }

    function hide() {
      banner.classList.remove('is-visible');
      banner.classList.remove('show-prefs');
      banner.setAttribute('aria-hidden', 'true');
    }

    function apply(consent) {
      writeLocal(consent);
      hide();
      pushToApi(privacy, consent);
    }

    banner.querySelectorAll('[data-consent-accept]').forEach(function (b) {
      b.addEventListener('click', function () {
        apply({ marketing: true, analytics: true, preferences: true, sale_of_data: true });
      });
    });

    banner.querySelectorAll('[data-consent-reject]').forEach(function (b) {
      b.addEventListener('click', function () {
        apply({ marketing: false, analytics: false, preferences: false, sale_of_data: false });
      });
    });

    banner.querySelectorAll('[data-consent-save]').forEach(function (b) {
      b.addEventListener('click', function () {
        var analytics = !!(banner.querySelector('[data-cat="analytics"]') || {}).checked;
        var marketing = !!(banner.querySelector('[data-cat="marketing"]') || {}).checked;
        var preferences = !!(banner.querySelector('[data-cat="preferences"]') || {}).checked;
        apply({
          marketing: marketing,
          analytics: analytics,
          preferences: preferences,
          sale_of_data: marketing
        });
      });
    });

    banner.querySelectorAll('[data-consent-prefs]').forEach(function (b) {
      b.addEventListener('click', function () {
        banner.classList.toggle('show-prefs');
      });
    });

    function openSettings(e) {
      if (e) e.preventDefault();
      var stored = readLocal();
      var current = apiConsent(privacy) || (stored ? stored.c : null);
      if (current) {
        CATS.forEach(function (k) {
          var el = banner.querySelector('[data-cat="' + k + '"]');
          if (el) el.checked = !!current[k];
        });
      }
      banner.classList.add('show-prefs');
      show();
    }

    window.openCookieSettings = openSettings;
    document.querySelectorAll('[data-open-cookie-settings]').forEach(function (el) {
      el.addEventListener('click', openSettings);
    });

    var stored = readLocal();
    var fromApi = apiConsent(privacy);

    if (stored) {
      if (!fromApi) pushToApi(privacy, stored.c);
      return;
    }

    if (fromApi) {
      writeLocal(fromApi);
      return;
    }

    var shouldShow = true;
    try {
      if (privacy && typeof privacy.shouldShowBanner === 'function') {
        shouldShow = privacy.shouldShowBanner();
      }
    } catch (e) {
      shouldShow = true;
    }

    if (shouldShow) show();
  }

  ready(function () {
    if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      window.Shopify.loadFeatures(
        [{ name: 'consent-tracking-api', version: '0.1' }],
        function (error) {
          var privacy = (!error && window.Shopify.customerPrivacy) ? window.Shopify.customerPrivacy : null;
          initBanner(privacy);
        }
      );
    } else {
      initBanner(null);
    }
  });
})();
